import styled from 'styled-components'

export const Centered = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`

export const Logo = styled.div`
  color: white;
  line-height: 32px;
  text-align: center;
  height: 32px;
  background: rgba(255, 255, 255, 0.2);
  margin: 4px;
`

export const MenuWrapper = styled.div`
  float: right;
  padding: 0px 40px 0px 0px;
`

export const styles = {
  content: {
    padding: 24,
    background: '#fff',
    maxHeight: 'calc(100vh - 64px)',
    overflowY: 'auto',
  },
}
